import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable import/first */

/**
 * Entry point for the React app on the client side
 */
if (window.resourceBaseUrl) {
  __webpack_public_path__ = "".concat(window.resourceBaseUrl, "/dist/"); // eslint-disable-line
}

import 'helpers/ie11-classlist-polyfill';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import DAL from '@classpass/dal';
import AjaxClient from '@classpass/dal/ajax-client';
import publicEndpoints from '@classpass/dal/public-endpoints';
import { Provider as ReduxProvider } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import { Router, match, browserHistory } from 'react-router';
import clientConfig from 'universal-config';
import createStore from 'redux/create';
import { setStore } from 'store';
import { ClientProvider } from 'providers/ClientProvider';
import supportedLocales from 'locales/supported-locales.json';
import { setLocale } from 'redux/modules/locale';
import { setRequestDetailsOnClient } from 'redux/modules/request';
import { trackApiRequest, trackApiResult } from 'helpers/statsd';
import { setDeviceType, setUserId } from 'helpers/multitrack';
import { isMobileDevice } from 'helpers/isMobile';
import routes from 'routes';
var transport = new AjaxClient({
  token: clientConfig().unauthenticatedToken
}, "".concat(window.location.protocol, "//").concat(window.location.host, "/_api"));
transport.on('request', function (event) {
  return trackApiRequest(false, event);
});
transport.on('success', function (event) {
  return trackApiResult(false, event);
});
transport.on('failure', function (event) {
  return trackApiResult(false, event);
});

if (__LOCAL_DEV__) {
  /* eslint-disable no-console */
  var logSuccess = function logSuccess(onServer, event) {
    if (event.params && Object.keys(event.params).length) {
      console.info("%c[API".concat(onServer ? ' (server)' : '', "] %c").concat(event.method, "%c to %c").concat(event.name, " (").concat(event.url, ")%c took %c").concat(event.duration, "ms%c with %O"), 'font-weight: bold', 'color:purple', '', 'color:green', '', 'color:blue', '', event.params);
    } else {
      console.info("%c[API".concat(onServer ? ' (server)' : '', "] %c").concat(event.method, "%c to %c").concat(event.name, " (").concat(event.url, ")%c took %c").concat(event.duration, "ms"), 'font-weight: bold', 'color:purple', '', 'color:green', '', 'color:blue');
    }
  };

  var logFailure = function logFailure(onServer, event) {
    if (event.params && Object.keys(event.params).length) {
      console.info("%c[API".concat(onServer ? ' (server)' : '', "] %cFAILURE ").concat(event.code || event.httpStatus, " %c").concat(event.method, "%c to %c").concat(event.name, " (").concat(event.url, ")%c took %c").concat(event.duration, "ms%c with %O"), 'font-weight: bold', 'color: red; font-weight: bold', 'color:purple', '', 'color:green', '', 'color:blue', '', event.params);
    } else {
      console.info("%c[API".concat(onServer ? ' (server)' : '', "] %cFAILURE ").concat(event.code || event.httpStatus, " %c").concat(event.method, "%c to %c").concat(event.name, " (").concat(event.url, ")%c took %c").concat(event.duration, "ms"), 'font-weight: bold', 'color: red; font-weight: bold', 'color:purple', '', 'color:green', '', 'color:blue');
    }
  };

  var requestLogNode = document.getElementById('api-requests');

  if (requestLogNode) {
    var apiRequestsMadeOnServer = JSON.parse(requestLogNode.textContent);
    apiRequestsMadeOnServer.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          type = _ref2[0],
          event = _ref2[1];

      if (type === 'success') {
        logSuccess(true, event);
      } else {
        logFailure(true, event);
      }
    });
  }

  transport.on('success', logSuccess.bind(this, false));
  transport.on('failure', logFailure.bind(this, false));
  /* eslint-enable no-console */
}

var client = new DAL(transport, publicEndpoints);
client.setUnauthenticatedToken(clientConfig().unauthenticatedToken);
client.setHeader('platform', clientConfig().platform);

if (__LOCAL_DEV__) {
  window._client = client; // eslint-disable-line no-underscore-dangle
}

var dest = document.getElementById('content');
var storeData = JSON.parse(document.getElementById('store').textContent);

var _createStore = createStore(browserHistory, storeData),
    store = _createStore.store,
    history = _createStore.history;

setStore(store);

if (!storeData.locale) {
  store.dispatch(setLocale(supportedLocales[0]));
}

if (store.getState().user.token) {
  client.useToken(store.getState().user.token);
}

if (storeData.entities.userProfile.data.default) {
  setUserId(storeData.entities.userProfile.data.default.id);
}

setDeviceType(isMobileDevice() ? 'phone' : 'desktop');

var createElement = function createElement(Component, componentProps) {
  [].concat(Component.sagas || []).forEach(function (saga) {
    return store.runSaga(saga, client);
  });
  return React.createElement(Component, componentProps);
};

var routerLocation = history.createLocation(window.location.pathname + window.location.search);
var currentLocation;
history.listen(function historyListener(location) {
  if (window.ga) {
    window.ga('set', 'page', location.pathname);
  }

  store.dispatch(setRequestDetailsOnClient());
  var prevUrl = currentLocation ? currentLocation.pathname + currentLocation.search : null;
  var currentUrl = location.pathname + location.search;

  if (prevUrl !== currentUrl) {
    var event = document.createEvent('Event');
    event.previousUrl = currentLocation ? currentLocation.pathname : null;
    event.currentUrl = location.pathname;
    event.initEvent('historyChanged', true, true);
    document.body.dispatchEvent(event);
  }

  currentLocation = location;
  return historyListener;
}(routerLocation));

var onReactRouterError = function onReactRouterError(error) {
  console.error('React Router onError', error); // eslint-disable-line no-console

  if (window.Rollbar) {
    window.Rollbar.error(error);
  }
};

var _ref3 = window._locale || {},
    localeCode = _ref3.code,
    messages = _ref3.messages,
    formatData = _ref3.formatData; // eslint-disable-line no-underscore-dangle


addLocaleData(formatData);
client.setHeader('Accept-Language', localeCode || supportedLocales[0]);
match({
  routes: routes(store, client),
  location: routerLocation,
  history: history
}, function (err, redirectLocation, renderProps) {
  if (err) {
    onReactRouterError(err);
  } // DANGER WILL ROBINSON: history= must come AFTER renderProps
  // so it clobbers renderProps.history


  var component = React.createElement(Router, _extends({}, renderProps, {
    createElement: createElement,
    onError: onReactRouterError,
    history: history
  }));
  ReactDOM.render(React.createElement(IntlProvider, {
    defaultLocale: "en-US",
    locale: localeCode || 'en-US',
    messages: messages
  }, React.createElement(ReduxProvider, {
    store: store,
    key: "provider"
  }, React.createElement(ClientProvider, {
    client: client
  }, component))), dest);

  if (process.env.NODE_ENV !== 'production') {
    window.React = React; // enable debugger
  }

  if (__DEVTOOLS__ && !window.devToolsExtension) {
    var DevTools = require('containers/DevTools/DevTools').DevTools;

    ReactDOM.render(React.createElement(IntlProvider, {
      defaultLocale: "en-US",
      locale: localeCode || 'en-US',
      messages: messages
    }, React.createElement(ReduxProvider, {
      store: store,
      key: "provider"
    }, React.createElement(ClientProvider, {
      client: client
    }, React.createElement(Fragment, null, component, React.createElement(DevTools, null))))), dest);
  }
});